import { render, staticRenderFns } from "./ModalUploadFileConfirm.vue?vue&type=template&id=563681fd&scoped=true"
import script from "./ModalUploadFileConfirm.vue?vue&type=script&lang=js"
export * from "./ModalUploadFileConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadFileConfirm.vue?vue&type=style&index=0&id=563681fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563681fd",
  null
  
)

export default component.exports